export default __webpack_public_path__ + "static/media/OverActive.c808767e.svg";